import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

const IssuingTaxAuthorityDropdownItem = ({ option, onClick, selected }) => {
  const onOptionClicked = useCallback(() => {
    onClick(option.code);
  }, [onClick, option.code]);

  return (
    <DropdownMenuItem key={option.code} onClick={onOptionClicked} selected={selected}>
      {option.label}
    </DropdownMenuItem>
  );
};

IssuingTaxAuthorityDropdownItem.propTypes = {
  option: PropTypes.shape({
    code: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default IssuingTaxAuthorityDropdownItem;
